export const org = {
  orgs: [{ id: 'org_demo', name: 'Acme Ecommerce', plan: 'starter' }],
  clients: [],
};
